import { useState } from 'react'

// Adjusts state during render (rather than in an effect) when a value
// changes -- returns true exactly on the render where `value` differs
// from its previous render, per
// https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
function useHasChanged(value) {
  const [prev, setPrev] = useState(value)
  const changed = value !== prev

  if (changed) setPrev(value)

  return changed
}

export default useHasChanged
